import { approveProspect, checkProspect, callbackProspect, convertProspect, denyProspect, getProspects, updateProspectOrientation } from '../api';
import { dispatchGrassError } from './index';
import { APPROVE_PROSPECT_SUCCESS, CHECK_PROSPECT_SUCCESS, CALLBACK_PROSPECT_SUCCESS, CONVERT_PROSPECT_SUCCESS, DENY_PROSPECT_SUCCESS, GET_ALL_PROSPECTS_SUCCESS, UPDATE_PROSPECT_SUCCESS } from './actionTypes';
import { dispatchErrorAction } from './index';

  export function approveWorkerProspect (formData) {
    return dispatch => approveProspect(formData)
      .then(({ data }) => {
        dispatch({ type: APPROVE_PROSPECT_SUCCESS, data });
        return { data }
      })
      .catch(error => dispatchGrassError(error, dispatch));
  }

  export function checkWorkerProspect (formData) {
    return dispatch => checkProspect(formData)
      .then(({ data }) => {
        dispatch({ type: CHECK_PROSPECT_SUCCESS, data });
        return { data }
      })
      .catch(error => dispatchGrassError(error, dispatch));
  }

  export function callbackWorkerProspect (formData) {
  return dispatch => callbackProspect(formData)
    .then(({ data }) => {
      dispatch({ type: CALLBACK_PROSPECT_SUCCESS, data });
      return { data }
    })
    .catch(error => dispatchGrassError(error, dispatch));
}

  export function convertWorkerProspect (formData) {
  return dispatch => convertProspect(formData)
    .then(({ data }) => {
      dispatch({ type: CONVERT_PROSPECT_SUCCESS, data });
      return { data }
    })
    .catch(error => dispatchGrassError(error, dispatch));
}

  export function denyWorkerProspect (formData) {
    return dispatch => denyProspect(formData)
      .then(({ data }) => {
        dispatch({ type: DENY_PROSPECT_SUCCESS, data });
        return { data }
      })
      .catch(error => dispatchGrassError(error, dispatch));
  }

  export function getAllProspects (skip = 0, filterData) {
    return dispatch => getProspects(skip, filterData)
      .then(({ data }) => {
        const pagesQuantity = data.total_pages
        dispatch({ type: GET_ALL_PROSPECTS_SUCCESS, prospectsList: data.prospects, pagesQuantity });
        return { data: data.prospects, pagesQuantity };
      })
      .catch(error => dispatchErrorAction(error, dispatch));
  }

  export function updateWorkerProspectOrientation (id, orientation_id) {
    return dispatch => updateProspectOrientation(id, orientation_id)
      .then(({ data }) => {
        dispatch({ type: UPDATE_PROSPECT_SUCCESS, data })
        return { data }
      })
      .catch(error => dispatchGrassError(error, dispatch));
  }



// WEBPACK FOOTER //
// ./src/actions/prospects.js